import _ from 'lodash';
import { lsRecommendedServiceItemIconStatusConstants } from './LsRecommendedServiceItemConstants';

const getRecommendedServiceItemDisplayValues = ({ recommendation }) => {
  const { icon, status } = _.cloneDeep(
    lsRecommendedServiceItemIconStatusConstants[recommendation.status]
  );
  const endDate = _.get(recommendation, status.endDatePath);

  return {
    icon,
    statusText: status.text,
    endDate,
  };
};
// eslint-disable-next-line import/prefer-default-export
export const lsRecommendedServiceItemHelpers = { getRecommendedServiceItemDisplayValues };
